import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	copyLinkSuccessTitle: {
		id: 'work-management-board.controllers.card-actions.copy-link-success-title',
		defaultMessage: 'Link copied',
		description: 'Flag title for successful copy',
	},
	copyLinkSuccessDescription: {
		id: 'work-management-board.controllers.card-actions.copy-link-success-description',
		defaultMessage: 'Item successfully copied to your clipboard.',
		description: 'Flag description for successful copy',
	},
});
